import { generateClient } from 'aws-amplify/api';

let clientInstance: any = null;

export function getGraphQLClient() {
  if (!clientInstance) {    
    clientInstance = generateClient();
  }
  return clientInstance;
}

export { getGraphQLClient as generateClient };